module.exports = __webpack_public_path__ + "img/subaru_thumbnail.5aa7ff16.png";